import * as React from 'react';

export interface ColumnSizeMap {
  /**
   * Xtra small screen size
   */
  xs?: string | number;
  /**
   * Small screen size
   */
  sm?: string | number;
  /**
   * Medium small screen size
   */
  md?: string | number;
  /**
   * Large screen size, 992px +
   */
  lg?: string | number;
  /**
   * 1200px +
   */
  xl?: string | number;
}

/**
 * Define a set of responsive column sizes per screen size, and transform those
 * into valid css flexbox classes
 *
 * @param size
 */
export const withSize = (sizes: ColumnSizeMap) =>
  <P extends object>(
    WrappedComponent: (React.ComponentClass<P> | React.FC<P>)
  ): React.FC<P & { className: string }> =>
  (props: any) => {

  const toClass = (size: string) => sizes[size] ? `col-${size}-${sizes[size]}` : '';
  const sizeClasses = sizes ? Object.keys(sizes).map(toClass).join(' ') : '';

  return (
      <WrappedComponent
        {...props}
        className = {`${props.className} ${sizeClasses}`}
      />
    );
};

/**
 * Define a set of responsive column sizes in Tile, and transform those
 * into valid css flexbox classes
 *
 * @param size
 */
export const withTileSize = (sizes: ColumnSizeMap) =>
  <P extends object>(
    WrappedComponent: (React.ComponentClass<P> | React.FC<P>),
    uiEngineProps
  ): React.FC<P & { className: string }> =>
  (props: any) => {

  const isInTile = uiEngineProps.resolveContext && uiEngineProps.resolveContext.path.length > 1;
  const toClass = (size: string) => sizes[size] ? `custom-col-${size}-${sizes[size]}` : '';
  const sizeClasses = sizes && isInTile ? Object.keys(sizes).map(toClass).join(' ') : '';

  return (
      <WrappedComponent {...props} className={`${props.className} ${sizeClasses}`} />
    );
};

export const withExpandAllSize = (sizes: ColumnSizeMap) =>
  <P extends object>(
    WrappedComponent: (React.ComponentClass<P> | React.FC<P>),
    uiEngineProps
  ): React.FC<P & { className: string }> =>
  (props: any) => {

    const hostprops = uiEngineProps.hostProps();

  const toClass = (size: string) => sizes[size] ? `custom-col-${size}-${sizes[size]}` : '';
  const sizeClasses = sizes && (hostprops && hostprops.expandAll) ? Object.keys(sizes).map(toClass).join(' ') : '';

  return (
      <WrappedComponent {...props} className={`${props.className} ${sizeClasses}`} />
    );
};
